import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// store / airport routing
const Ad = Loadable(lazy(() => import('views/pages/ad/Ad')));
// const AdFlow = Loadable(lazy(() => import('views/pages/ad/AdFlow')));
const AdType    = Loadable(lazy(() => import('views/pages/adType/AdType')));
const Airport     = Loadable(lazy(() => import('views/pages/airport/Airport')));
const User        = Loadable(lazy(() => import('views/pages/user/User')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <Ad />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        },
        // {
        //   path: 'flow',
        //   element: <AdFlow />
        // }
      ]
    },
    {
      path: '/ads',
      element: <Ad />
    },
    {
      path: '/adtypes',
      element: <AdType />
    },
    {
      path: '/airports',
      element: <Airport />
    },
    {
      path: '/users',
      element: <User />
    },
    
  ]
};

export default MainRoutes;
